import React, { FC } from "react";
import { YhFormBox } from "@/components/YhFormBox";
import { IYhFormBox, IYhFormItemsBox, FormItemTypeEnum, ISelectOption } from "@/components/YhFormBox/Types";
import { RouterParamType } from "@/model/navModel";
import { useCceDetailModel } from "../cceDetailModel";
import { DictCodeEnmu } from "@/types/AppDictEnums";
import { useDictModel } from "@/views/base/dict/dictModel";

export const FormBox: FC<RouterParamType> = ({ id, mode, formRef }) => {
    const {
        addFormVal,
        editFormVal,
        updateFormVal,
    } = useCceDetailModel(({ addFormVal, editFormVal }) => [addFormVal, editFormVal]);
    const { getSelectedDictOne } = useDictModel(() => []);
    const formVal = mode === "edit" ? editFormVal : addFormVal;

    //币种选中
    const currencyChange = (value: string, option: ISelectOption) => {
        option && updateFormVal(mode, { currencyCode: option.value, currencyName: option.label });
    }

    //表单change
    const onChange = (changedValues: { [key: string]: any }, values: any) => {
        updateFormVal(mode, values);
    }

    const baseFormItem: IYhFormItemsBox = {
        title: "关系人",
        style: { padding: "10px 0 0 0", marginBottom: "10px" },
        contentClass: "pr-2",
        items: [
            {
                type: FormItemTypeEnum.TextArea,
                fieldLabel: "开证人",
                fieldName: "opener",
                span: 12
            }, {
                type: FormItemTypeEnum.TextArea,
                fieldLabel: "品名描述",
                fieldName: "description",
                span: 12
            }, {
                type: FormItemTypeEnum.TextArea,
                fieldLabel: "开证银行",
                fieldName: "issuingBank",
                span: 12
            }, {
                type: FormItemTypeEnum.TextArea,
                fieldLabel: "收货人",
                fieldName: "consignee",
                span: 12
            }, {
                type: FormItemTypeEnum.TextArea,
                fieldLabel: "受益人",
                fieldName: "beneficiary",
                span: 12
            }, {
                type: FormItemTypeEnum.Select,
                fieldLabel: "汇票人选择",
                fieldName: "payer",
                options: [
                    { label: '开证人', value: 'opener' },
                    { label: '开证行', value: 'issuingBank' },
                    { label: '收货人', value: 'consignee' },
                ],
                span: 6,
                labelCol: { span: 8 },
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "汇票期限(天)",
                fieldName: "draftAt",
                span: 6,
                labelCol: { span: 8 },
            }, {
                type: FormItemTypeEnum.TextArea,
                fieldLabel: "议付银行",
                fieldName: "negotiationBank",
                span: 12
            },
            {
                type: FormItemTypeEnum.TextArea,
                fieldLabel: "汇票付款人",
                fieldName: "drawee",
                span: 12
            },
            {
                type: FormItemTypeEnum.Select,
                fieldLabel: "装货港",
                fieldName: "shipment",
                span: 12,
                labelCol: { span: 4 },
                options: getSelectedDictOne(DictCodeEnmu.LOAD_PORT),
            }, {
                type: FormItemTypeEnum.Select,
                fieldLabel: "卸货港",
                fieldName: "discharge",
                options: getSelectedDictOne(DictCodeEnmu.DISCHARTGE_PORT),
                span: 12,
                labelCol: { span: 4 },
            },
            {
                type: FormItemTypeEnum.TextArea,
                fieldLabel: "提单抬头人",
                fieldName: "bearer",
                span: 12
            },
            {
                type: FormItemTypeEnum.TextArea,
                fieldLabel: "提单通知人",
                fieldName: "ladingNotifier",
                span: 12
            },
        ]
    };

    const relatedFromConfig: IYhFormBox = {
        formRef,
        labelCol: { span: 4 },
        labelAlign: "right",
        formValues: formVal,
        onChange,
        boxs: [baseFormItem]
    }


    return (
        <YhFormBox {...relatedFromConfig} />
    )
}